import { makeAutoObservable } from 'mobx';
import { CalendarEvent } from '../pages/course/lectures/calendar/big-calendar/course-lecture-event-calendar';
import { loadCalendarEventsOperations } from './calendar/operations/load-calendar-events-operations';
import globalConfigStore from './global-config-store';

class GlobalCourseCalendarStore {
  date: Date | null = new Date();
  displayView: 'month' | 'week' | 'day' = 'month';

  events: CalendarEvent[] = [];

  constructor() {
    makeAutoObservable(this); // This automatically makes everything observable
  }

  async loadCalendarEvents(
    branchId: number | undefined,
    year: number,
    month: number,
  ) {
    try {
      const events = await loadCalendarEventsOperations(
        globalConfigStore.rootFilter?.currentBranches?.id,
        year,
        month,
      );

      this.events = events;
    } catch (e) {
      throw e;
    }
  }

  setEvents(events: CalendarEvent[]) {
    this.events = events;
  }
}

const globalCourseCalendarStore = new GlobalCourseCalendarStore();
export default globalCourseCalendarStore;
